import React, { useEffect, useState } from 'react';
import './Events.css';
import SecondaryNavbar from '../../components/SecondaryNavbar/SecondaryNavbar';


const Events = () => {
  const events = [
    { 
      id: 1, 
      title: 'Escape Room', 
      content: 'Robots battle in an epic showdown', 
      imageSrc: require('../../components/Assets/Events/Escape_techno25-26.png'), 
      info: 'Step into a high-voltage mystery at Escape Room: Escape the Electric Room, where tension crackles in the air and every second counts. Locked inside a charged control room filled with cryptic clues and hidden mechanisms, you and your team must think fast, communicate smartly, and solve intricate puzzles before time runs out. Decode messages, uncover secrets, and navigate unexpected twists in an immersive experience that blends logic, creativity, and adrenaline. The clock is ticking, the pressure is rising, and only the sharpest minds will make it out in time. Do you have the courage, strategy, and teamwork needed to escape the Electric Room?',
      
    },
    { 
      id: 2, 
      title: 'Robo Soccer', 
      content: 'Football, but with robots!', 
      imageSrc: require('../../components/Assets/Events/Robo_soccer_techno25-26.png'),
      info: 'Football is the beautiful game, and when it\'s played by robots, it’s pure innovation. Get ready for a spectacular fusion of engineering and soccer! Welcome to Robo Soccer at Technovanza 2025, where we redefine the love for football with the magic of robotics. Build your manual soccer-playing bots, strategize your moves, and channel the brilliance of Messi, Ronaldo, or Neymar—robotic style! No screens. No controllers. Just pure, heart-pounding action on the field. As your bot dribbles, defends, and scores, the arena will come alive with cheers and adrenaline. It’s time to stop watching and start playing. So, gather your squad, get your bots ready, and bring the trophy home. Are you ready to kick it? Because Robo Soccer is where the future of football begins!' ,
      brochure: 'https://drive.google.com/file/d/16HDiAqLre3iyO2OvhgIbx9sTbfc45yaC/view?usp=drive_link',
      register: 'https://unstop.com/o/7VJ0q5A?lb=uImoFA8T&utm_medium=Share&utm_source=vjtitec2424&utm_campaign=Competitions'
    },
    { 
      id: 3, 
      title: 'Robo Strike', 
      content: 'Battle bots in a strategic combat competition', 
      imageSrc: require('../../components/Assets/Events/Robo_strike_techno25-26.png'),
      info: 'Every strike is a chance to turn dreams into reality! Brace yourselves for the electrifying Robo Strike, where innovation meets the thrill of the arcade! Technovanza 2025 invites you to unleash your inner robotic genius in this unique mashup of Air Hockey and Robotics. Build and command your bots to glide, strike, and dominate the arena in an intense battle of skill and precision. It’s not just about hitting the puck—it’s about hitting it with strategy, speed, and strength. Each strike is a step closer to glory, and every second is a chance to outmaneuver your opponent. Will your bot bring home the winning strike? Game on, engineers! Let’s make it a showdown to remember.' ,
      brochure: 'https://drive.google.com/file/d/1nX2ZTq0ZT7agiDFfTw3eARef4rDrzaK-/view?usp=drive_link',
      register: 'https://unstop.com/competitions/robostrike-veermata-jijabai-technological-institute-vjti-mumbai-1645991?lb=uImoFA8T'
    },
    { 
      id: 4, 
      title: 'VMCO', 
      content: 'Bot battles in a sumo wrestling arena', 
      imageSrc: require('../../components/Assets/Events/VMCO_techno_25-26.png'),
      info: 'Technovanza brings you a Rubik’s Cube competition — VJTI Mumbai Cube Open! Get ready to put your muscle memory, speed, and spatial thinking skills to the test. With 4 exciting events — 3x3x3, 4x4x4, One-Handed 3x3x3, and Blindfolded 3x3x3 — participants will challenge their coordination, strategy, and understanding while competing with fellow cubers.',
      brochure: 'https://drive.google.com/file/d/1fuf6RQ5mBQFEFsD7ij0b0kMjwKEJpdlb/view?usp=drive_link',
      register: 'https://unstop.com/events/vjti-mumbai-cube-open-vmco-veermata-jijabai-technological-institute-vjti-mumbai-1644510?lb=AYmwA6FY'
    }, 
    { 
      id: 5, 
      title: 'VRC', 
      content: 'VJTI Robotics Competition: Design, build, and compete', 
      imageSrc: require('../../components/Assets/Events/VRC_techno25-26.png'),
      info: 'Every innovation starts as an idea, and every champion starts as a challenger. Technovanza 2025 invites you to the VJTI Robotics Challenge (VRC) – the ultimate test of creativity, engineering, and strategy! This year, the battlefield takes a virtual leap, blending technology with imagination. In this UNITY Game Engine-based simulation, you will design, build, and program your virtual bots to navigate through challenging arenas filled with intricate obstacles and tasks. Whether it’s crafting precise models or coding flawless algorithms, the power is in your hands to shape your bot into a champion. Compete in a world where every decision matters, where innovation meets execution, and where skill defines success. Let your creativity shine as you take on the Virtual VRC, where the thrills of robotics come alive in an immersive online format. Are you ready to rise to the challenge? Step into the virtual arena and make your mark!',
      brochure: 'https://unstop.com/competitions/vjti-robotics-challenge-technovanza-vjti-veermata-jijabai-technological-institute-vjti-mumbai-609766' 
    },
    { 
      id: 6, 
      title: 'Monster Arena', 
      content: 'Monster trucks meet robots in the ultimate arena battle!', 
      imageSrc: require('../../components/Assets/Events/Monster_techno25-26.png'),
      info: 'A monster isn\'t born... A monster is made! Technovanza 2025 proudly brings you Monster Arena, where legends are forged in the fiery crucible of challenges.Burnt like a brick in fire, shaped by every hurdle, this is the tale of creating something extraordinary. Beneath the stars and amidst the cosmic expanse, your monster awaits its moment to shine. Let’s embark on this stellar journey—across galaxies, over moons, and through the technical universe—to bring forth your monster.Are you ready to unleash the ultimate creation and conquer the Monster Arena?' ,
      brochure: 'https://drive.google.com/file/d/1s7kZUNRTJDsrqLf0uH1hGHKThVxxuLyy/view?usp=drive_link',
      register: 'https://unstop.com/competitions/monster-arena-veermata-jijabai-technological-institute-vjti-mumbai-1646140'
    },
    { 
      id: 7, 
      title: 'F1 Power Drift', 
      content: 'Race remote-controlled cars at high speed!', 
      imageSrc: require('../../components/Assets/Events/F1_techno25-26.png'),
      info: 'Get ready for the ultimate racing experience at the F1 Power Drift Grand Prix! This year, it’s all about speed, precision, and power drifting. Design your own high-performance race bots and take on a challenging track full of tight turns and obstacles. Test your skills in this high-octane race, where only the fastest and most agile bots will succeed. It’s time to show off your drifting mastery and cross the finish line in style. Are you ready to drift your way to victory? Join us at Technovanza 2025!' ,
      brochure: 'https://drive.google.com/file/d/1uOtvc8R0pw7vUOzTuAZDfq3gE3sKgG76/view?usp=drive_link',
      register: 'https://unstop.com/competitions/power-drift-grand-prix-veermata-jijabai-technological-institute-vjti-mumbai-1642393'
    },
    
    { 
      id: 9, 
      title: 'Techno CP', 
      content: 'Code your way to victory!', 
      imageSrc: require('../../components/Assets/Events/Cp_techno25-26.png'),
      info: 'Step into the world of algorithms, logic, and lightning-fast thinking at TechnoCP, the ultimate competitive programming showdown at Technovanza 2025–26. Designed to test your problem-solving skills under pressure, this contest challenges participants to decode complex problems, optimize solutions, and think beyond conventional approaches. Whether you\'re a seasoned coder or an aspiring programmer, TechnoCP pushes you to sharpen your analytical abilities and master the art of efficient coding. Compete against the brightest minds, climb the leaderboard, and prove your coding prowess. With prizes worth INR 20,000 at stake, the challenge is real, the competition fierce, and the glory unforgettable.' ,
      brochure: 'https://drive.google.com/file/d/153oK_dqLi7yJYwjx2VZ6xRr5rkCniB6a/view?usp=drive_link',
      register: 'https://unstop.com/hackathons/technocp-veermata-jijabai-technological-institute-vjti-mumbai-1646160'
    },
    
    { 
      id: 11, 
      title: 'Code Relay', 
      content: 'Bot battles in a sumo wrestling arena', 
      imageSrc: require('../../components/Assets/Events/Code_relay_techno25-26.png'),
      info: 'Welcome to Code Relay, where coding meets creativity, and teamwork drives triumph! Get ready to dive into a dynamic team-based challenge that’s as much about collaboration as it is about code. In this high-energy competition, your mission is to recreate a visually stunning website using modern web technologies. Sounds simple? Here’s the twist: it’s a relay! Each team member will take the baton to code their part within a limited time before passing it on. Precision and seamless coordination are the keys to victory. As the timer counts down, can you adapt, communicate, and code under pressure to piece together the perfect design? The team that delivers the most accurate replication wins not just the prize but the admiration of their peers. Think fast. Code faster. Relay to victory!' ,
      brochure: 'https://drive.google.com/file/d/1uUlKO7FOhEruRdMjmRslQCBBwVFoMrfS/view?usp=drive_link',
      register: 'https://unstop.com/hackathons/code-relay-veermata-jijabai-technological-institute-vjti-mumbai-1646156'
    },
    
    { 
      id: 13, 
      title: 'Prompt Battle', 
      content: 'Prompt Battle', 
      imageSrc: require('../../components/Assets/Events/prompt_techno25-26.png'),
      info: 'Step into the arena of ideas with Prompt Battle, where creativity meets ingenuity! This is your platform to think outside the box, innovate on the spot, and turn your concepts into groundbreaking solutions. Whether it\'s technical brilliance or imaginative storytelling, this battle will test your ability to adapt and impress in real time. Compete against the sharpest minds and let your ideas do the talking. The spotlight is yours—are you ready to take the stage and emerge victorious? Let the battle begin at Technovanza 2025!' ,
      brochure: 'https://drive.google.com/file/d/1kaWxIEcn4PyWh06lMIks5nFEIZPlEi6D/view?usp=drive_link'
    },    
       
  ];

  const [cardIndex, setCardIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);


  useEffect(() => {
    function rain() {
      const light = document.querySelector('.light');
      const e = document.createElement('div');
      const left = Math.floor(Math.random() * 310);
      const width = Math.random() * 5;
      const height = Math.random() * 50;
      const duration = Math.random() * 0.5;

      e.classList.add('drop');
      light.appendChild(e);
      e.style.left = left + 'px';
      e.style.width = 0.5 + width + 'px';
      e.style.height = 0.5 + height + 'px';
      e.style.animationDuration = 1 + duration + 's';

      setTimeout(() => {
        light.removeChild(e);
      }, 2000);
    }

    const interval = setInterval(rain, 20);
    return () => clearInterval(interval); 
  }, []);

  const handleEventClick = (index) => {
    setIsAnimating(true);
    setSelectedEvent(index);
    setTimeout(() => {
      setCardIndex(index);
      setIsAnimating(false);
    }, 700); 
  };

  const handleNextEvent = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setSelectedEvent((prev) => (prev + 1) % events.length);
      setCardIndex((prevIndex) => (prevIndex + 1) % events.length); 
      setIsAnimating(false);
    }, 700); 
  };

  const handlePreviousEvent = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setSelectedEvent((prev) => (prev - 1 + events.length) % events.length);
      setCardIndex((prevIndex) => (prevIndex - 1 + events.length) % events.length); 
      setIsAnimating(false);
    }, 700); 
  };

     const toggleDetails = () => {
    setIsDetailsVisible(!isDetailsVisible); // Toggle details visibility
  };

  return (
    <div className="full-bg">
      <SecondaryNavbar />
      <div className="events-navbar">
        {events.map((event, index) => (
          <p
            key={event.id}
            className={`event ${selectedEvent === index ? "highlighted" : ""}`}
            onClick={() => handleEventClick(index)}
          >
            <span aria-hidden="true">{event.title}</span>
            {event.title}
            <span aria-hidden="true">{event.title}</span>
          </p>
        ))}
      </div>


      <div className="container">
        <div className="light"></div>
      </div>


     <div className={`card ${isAnimating ? 'card-exit-active' : 'card-enter-active'}`}>
      {events[cardIndex].imageSrc && (
        <img
          src={events[cardIndex].imageSrc}
          alt={events[cardIndex].title}
          className="card-image"
        />
      )}
       <div className="card-overlay">
          {/* <h2 className="card-title">{events[cardIndex].title}</h2> */}
          {/* <p className="card-content">{events[cardIndex].content}</p> */}
       </div>
    </div>

    <button className="see-more-btn" onClick={toggleDetails}>
        {isDetailsVisible ? 'Close' : 'See More'}
      </button>

        <div className={`event-details-container ${isDetailsVisible ? 'visible' : ''}`}>
        <div className={`event-details-box ${isAnimating ? 'details-exit-active' : 'details-enter-active'}`}>
          <h2>{events[cardIndex].title}</h2>
          <p>{events[cardIndex].info}</p>

          <div className="event-buttons">
              {events[cardIndex].register && ( // Check if brochure exists
                <div 
                  className="register-btn" 
                  onClick={() => window.open(events[cardIndex].register, '_blank')}
                >
                  <span>Register</span>
                </div>
              )}
            
              
             </div>
        </div>
      </div>
     
        <div className="button-container">
            <div className="button" onClick={handlePreviousEvent}>
                <div className="line-container">
                    <span className="text">Previous</span>
                    <div className="line line--top-left line--thick thick-line--short"></div>
                    <div className="line line--top-right line--thick thick-line--short"></div>
                    <div className="line line--bottom-left line--thick thick-line--long"></div>
                    <div className="line line--bottom-right line--thick thick-line--long"></div>
                    <div className="line line--top line--thin"></div>
                    <div className="line line--bottom line--thin"></div>
                    </div>
            </div>
            
            <div className="button" onClick={handleNextEvent}>
                <div className="line-container">
                    <span className="text">Next</span>
                    <div className="line line--top-left line--thick thick-line--short"></div>
                    <div className="line line--top-right line--thick thick-line--short"></div>
                    <div className="line line--bottom-left line--thick thick-line--long"></div>
                    <div className="line line--bottom-right line--thick thick-line--long"></div>
                    <div className="line line--top line--thin"></div>
                    <div className="line line--bottom line--thin"></div>
                    </div>
            </div>

            
        </div>
    </div>
  );
};

export default Events;
